import request from '@/utils/request'

// 站点基本信息
export function appBasic() {
  return request({
    url: '/cms/openApi/basic/app/get' ,
    method: 'GET'
  })
}

// 获取人员证件资料
export function getPersonCre(params) {
  return request({
    url: '/cms/openApi/queryCre' ,
    method: 'POST',
    params
  })
}